// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/Poppins/Poppins-Thin.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/Poppins/Poppins-ExtraLight.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/Poppins/Poppins-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../fonts/Poppins/Poppins-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../fonts/Poppins/Poppins-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../fonts/Poppins/Poppins-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../fonts/Poppins/Poppins-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../fonts/Poppins/Poppins-ExtraBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../fonts/Poppins/Poppins-Black.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../fonts/Poppins/Poppins-ThinItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../fonts/Poppins/Poppins-ExtraLightItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../fonts/Poppins/Poppins-LightItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../fonts/Poppins/Poppins-Italic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../fonts/Poppins/Poppins-MediumItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../fonts/Poppins/Poppins-SemiBoldItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../fonts/Poppins/Poppins-BoldItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("../fonts/Poppins/Poppins-ExtraBoldItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("../fonts/Poppins/Poppins-BlackItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("../fonts/Montserrat/Montserrat-Thin.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("../fonts/Montserrat/Montserrat-ThinItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("../fonts/Montserrat/Montserrat-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("../fonts/Montserrat/Montserrat-LightItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("../fonts/Montserrat/Montserrat-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("../fonts/Montserrat/Montserrat-Italic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("../fonts/Montserrat/Montserrat-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("../fonts/Montserrat/Montserrat-MediumItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("../fonts/Montserrat/Montserrat-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("../fonts/Montserrat/Montserrat-BoldItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_28___ = new URL("../fonts/Montserrat/Montserrat-Black.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_29___ = new URL("../fonts/Montserrat/Montserrat-BlackItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_30___ = new URL("../fonts/Inter/Inter-Thin.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_31___ = new URL("../fonts/Inter/Inter-ExtraLight.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_32___ = new URL("../fonts/Inter/Inter-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_33___ = new URL("../fonts/Inter/Inter-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_34___ = new URL("../fonts/Inter/Inter-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_35___ = new URL("../fonts/Inter/Inter-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_36___ = new URL("../fonts/Inter/Inter-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_37___ = new URL("../fonts/Inter/Inter-ExtraBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_38___ = new URL("../fonts/Inter/Inter-Black.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_39___ = new URL("../fonts/Inter/Inter-ThinItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_40___ = new URL("../fonts/Inter/Inter-ExtraLightItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_41___ = new URL("../fonts/Inter/Inter-LightItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_42___ = new URL("../fonts/Inter/Inter-Italic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_43___ = new URL("../fonts/Inter/Inter-MediumItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_44___ = new URL("../fonts/Inter/Inter-SemiBoldItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_45___ = new URL("../fonts/Inter/Inter-BoldItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_46___ = new URL("../fonts/Inter/Inter-ExtraBoldItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_47___ = new URL("../fonts/Inter/Inter-BlackItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_48___ = new URL("../fonts/Roboto/Roboto-Thin.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_49___ = new URL("../fonts/Roboto/Roboto-ThinItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_50___ = new URL("../fonts/Roboto/Roboto-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_51___ = new URL("../fonts/Roboto/Roboto-LightItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_52___ = new URL("../fonts/Roboto/Roboto-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_53___ = new URL("../fonts/Roboto/Roboto-Italic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_54___ = new URL("../fonts/Roboto/Roboto-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_55___ = new URL("../fonts/Roboto/Roboto-MediumItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_56___ = new URL("../fonts/Roboto/Roboto-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_57___ = new URL("../fonts/Roboto/Roboto-BoldItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_58___ = new URL("../fonts/Roboto/Roboto-Black.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_59___ = new URL("../fonts/Roboto/Roboto-BlackItalic.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___);
var ___CSS_LOADER_URL_REPLACEMENT_29___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_29___);
var ___CSS_LOADER_URL_REPLACEMENT_30___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_30___);
var ___CSS_LOADER_URL_REPLACEMENT_31___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_31___);
var ___CSS_LOADER_URL_REPLACEMENT_32___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_32___);
var ___CSS_LOADER_URL_REPLACEMENT_33___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_33___);
var ___CSS_LOADER_URL_REPLACEMENT_34___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_34___);
var ___CSS_LOADER_URL_REPLACEMENT_35___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_35___);
var ___CSS_LOADER_URL_REPLACEMENT_36___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_36___);
var ___CSS_LOADER_URL_REPLACEMENT_37___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_37___);
var ___CSS_LOADER_URL_REPLACEMENT_38___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_38___);
var ___CSS_LOADER_URL_REPLACEMENT_39___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_39___);
var ___CSS_LOADER_URL_REPLACEMENT_40___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_40___);
var ___CSS_LOADER_URL_REPLACEMENT_41___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_41___);
var ___CSS_LOADER_URL_REPLACEMENT_42___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_42___);
var ___CSS_LOADER_URL_REPLACEMENT_43___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_43___);
var ___CSS_LOADER_URL_REPLACEMENT_44___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_44___);
var ___CSS_LOADER_URL_REPLACEMENT_45___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_45___);
var ___CSS_LOADER_URL_REPLACEMENT_46___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_46___);
var ___CSS_LOADER_URL_REPLACEMENT_47___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_47___);
var ___CSS_LOADER_URL_REPLACEMENT_48___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_48___);
var ___CSS_LOADER_URL_REPLACEMENT_49___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_49___);
var ___CSS_LOADER_URL_REPLACEMENT_50___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_50___);
var ___CSS_LOADER_URL_REPLACEMENT_51___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_51___);
var ___CSS_LOADER_URL_REPLACEMENT_52___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_52___);
var ___CSS_LOADER_URL_REPLACEMENT_53___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_53___);
var ___CSS_LOADER_URL_REPLACEMENT_54___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_54___);
var ___CSS_LOADER_URL_REPLACEMENT_55___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_55___);
var ___CSS_LOADER_URL_REPLACEMENT_56___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_56___);
var ___CSS_LOADER_URL_REPLACEMENT_57___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_57___);
var ___CSS_LOADER_URL_REPLACEMENT_58___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_58___);
var ___CSS_LOADER_URL_REPLACEMENT_59___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_59___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'Poppins';
  font-weight: 100;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

@font-face {
  font-family: 'Poppins';
  font-weight: 200;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

@font-face {
  font-family: 'Poppins';
  font-weight: 300;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

@font-face {
  font-family: 'Poppins';
  font-weight: 400;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

@font-face {
  font-family: 'Poppins';
  font-weight: 500;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}

@font-face {
  font-family: 'Poppins';
  font-weight: 600;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}

@font-face {
  font-family: 'Poppins';
  font-weight: 700;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}

@font-face {
  font-family: 'Poppins';
  font-weight: 800;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}

@font-face {
  font-family: 'Poppins';
  font-weight: 900;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}

@font-face {
  font-family: 'Poppins';
  font-weight: 100;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
}

@font-face {
  font-family: 'Poppins';
  font-weight: 200;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
}

@font-face {
  font-family: 'Poppins';
  font-weight: 300;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
}

@font-face {
  font-family: 'Poppins';
  font-weight: 400;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
}

@font-face {
  font-family: 'Poppins';
  font-weight: 500;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
}

@font-face {
  font-family: 'Poppins';
  font-weight: 600;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
}

@font-face {
  font-family: 'Poppins';
  font-weight: 700;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
}

@font-face {
  font-family: 'Poppins';
  font-weight: 800;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
}

@font-face {
  font-family: 'Poppins';
  font-weight: 900;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
}

@font-face {
  font-weight: 100;
  font-family: Montserrat;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
}

@font-face {
  font-weight: 100;
  font-family: Montserrat;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
}

@font-face {
  font-weight: 300;
  font-family: Montserrat;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
}

@font-face {
  font-weight: 300;
  font-family: Montserrat;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
}

@font-face {
  font-weight: 400;
  font-family: Montserrat;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_22___});
}

@font-face {
  font-weight: 400;
  font-family: Montserrat;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_23___});
}

@font-face {
  font-weight: 500;
  font-family: Montserrat;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_24___});
}

@font-face {
  font-weight: 500;
  font-family: Montserrat;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_25___});
}

@font-face {
  font-weight: 700;
  font-family: Montserrat;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_26___});
}

@font-face {
  font-weight: 700;
  font-family: Montserrat;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_27___});
}

@font-face {
  font-weight: 900;
  font-family: Montserrat;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_28___});
}

@font-face {
  font-weight: 900;
  font-family: Montserrat;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_29___});
}

@font-face {
  font-family: "Inter";
  font-weight: 100;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_30___});
}

@font-face {
  font-family: "Inter";
  font-weight: 200;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_31___});
}

@font-face {
  font-family: "Inter";
  font-weight: 300;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_32___});
}

@font-face {
  font-family: "Inter";
  font-weight: 400;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_33___});
}

@font-face {
  font-family: "Inter";
  font-weight: 500;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_34___});
}

@font-face {
  font-family: "Inter";
  font-weight: 600;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
}

@font-face {
  font-family: "Inter";
  font-weight: 700;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_36___});
}

@font-face {
  font-family: "Inter";
  font-weight: 800;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_37___});
}

@font-face {
  font-family: "Inter";
  font-weight: 900;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_38___});
}

@font-face {
  font-family: "Inter";
  font-weight: 100;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_39___});
}

@font-face {
  font-family: "Inter";
  font-weight: 200;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_40___});
}

@font-face {
  font-family: "Inter";
  font-weight: 300;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_41___});
}

@font-face {
  font-family: "Inter";
  font-weight: 400;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_42___});
}

@font-face {
  font-family: "Inter";
  font-weight: 500;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_43___});
}

@font-face {
  font-family: "Inter";
  font-weight: 600;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_44___});
}

@font-face {
  font-family: "Inter";
  font-weight: 700;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_45___});
}

@font-face {
  font-family: "Inter";
  font-weight: 800;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_46___});
}

@font-face {
  font-family: "Inter";
  font-weight: 900;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_47___});
}

@font-face {
  font-weight: 100;
  font-family: Roboto;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_48___});
}

@font-face {
  font-weight: 100;
  font-family: Roboto;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_49___});
}

@font-face {
  font-weight: 300;
  font-family: Roboto;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_50___});
}

@font-face {
  font-weight: 300;
  font-family: Roboto;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_51___});
}

@font-face {
  font-weight: 400;
  font-family: Roboto;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_52___});
}

@font-face {
  font-weight: 400;
  font-family: Roboto;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_53___});
}

@font-face {
  font-weight: 500;
  font-family: Roboto;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_54___});
}

@font-face {
  font-weight: 500;
  font-family: Roboto;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_55___});
}

@font-face {
  font-weight: 700;
  font-family: Roboto;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_56___});
}

@font-face {
  font-weight: 700;
  font-family: Roboto;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_57___});
}

@font-face {
  font-weight: 900;
  font-family: Roboto;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_58___});
}

@font-face {
  font-weight: 900;
  font-family: Roboto;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_59___});
}
`, "",{"version":3,"sources":["webpack://./src/shared-app/assets/styles/font.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,4CAA6C;AAC/C;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,4CAAmD;AACrD;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,4CAA8C;AAChD;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,4CAAgD;AAClD;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,4CAA+C;AACjD;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,4CAAiD;AACnD;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,4CAA6C;AAC/C;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,4CAAkD;AACpD;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,4CAA8C;AAChD;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,4CAAmD;AACrD;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,6CAAyD;AAC3D;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,6CAAoD;AACtD;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,6CAA+C;AACjD;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,6CAAqD;AACvD;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,6CAAuD;AACzD;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,6CAAmD;AACrD;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,6CAAwD;AAC1D;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,6CAAoD;AACtD;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,6CAAmD;AACrD;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,6CAAyD;AAC3D;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,6CAAoD;AACtD;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,6CAA0D;AAC5D;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,6CAAsD;AACxD;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,6CAAqD;AACvD;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,6CAAqD;AACvD;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,6CAA2D;AAC7D;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,6CAAmD;AACrD;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,6CAAyD;AAC3D;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,6CAAoD;AACtD;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,6CAA0D;AAC5D;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,6CAAyC;AAC3C;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,6CAA+C;AACjD;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,6CAA0C;AAC5C;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,6CAA4C;AAC9C;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,6CAA2C;AAC7C;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,6CAAyC;AAC3C;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,6CAA8C;AAChD;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,6CAA0C;AAC5C;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,6CAA+C;AACjD;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,6CAAqD;AACvD;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,6CAAgD;AAClD;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,6CAA2C;AAC7C;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,6CAAiD;AACnD;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,6CAAmD;AACrD;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,6CAA+C;AACjD;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,6CAAoD;AACtD;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,6CAAgD;AAClD;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,6CAA2C;AAC7C;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,6CAAiD;AACnD;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,6CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,6CAAkD;AACpD;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,6CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,6CAAmD;AACrD;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,6CAA2C;AAC7C;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,6CAAiD;AACnD;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,6CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,6CAAkD;AACpD","sourcesContent":["@font-face {\n  font-family: 'Poppins';\n  font-weight: 100;\n  src: url('../fonts/Poppins/Poppins-Thin.ttf');\n}\n\n@font-face {\n  font-family: 'Poppins';\n  font-weight: 200;\n  src: url('../fonts/Poppins/Poppins-ExtraLight.ttf');\n}\n\n@font-face {\n  font-family: 'Poppins';\n  font-weight: 300;\n  src: url('../fonts/Poppins/Poppins-Light.ttf');\n}\n\n@font-face {\n  font-family: 'Poppins';\n  font-weight: 400;\n  src: url('../fonts/Poppins/Poppins-Regular.ttf');\n}\n\n@font-face {\n  font-family: 'Poppins';\n  font-weight: 500;\n  src: url('../fonts/Poppins/Poppins-Medium.ttf');\n}\n\n@font-face {\n  font-family: 'Poppins';\n  font-weight: 600;\n  src: url('../fonts/Poppins/Poppins-SemiBold.ttf');\n}\n\n@font-face {\n  font-family: 'Poppins';\n  font-weight: 700;\n  src: url('../fonts/Poppins/Poppins-Bold.ttf');\n}\n\n@font-face {\n  font-family: 'Poppins';\n  font-weight: 800;\n  src: url('../fonts/Poppins/Poppins-ExtraBold.ttf');\n}\n\n@font-face {\n  font-family: 'Poppins';\n  font-weight: 900;\n  src: url('../fonts/Poppins/Poppins-Black.ttf');\n}\n\n@font-face {\n  font-family: 'Poppins';\n  font-weight: 100;\n  font-style: italic;\n  src: url('../fonts/Poppins/Poppins-ThinItalic.ttf');\n}\n\n@font-face {\n  font-family: 'Poppins';\n  font-weight: 200;\n  font-style: italic;\n  src: url('../fonts/Poppins/Poppins-ExtraLightItalic.ttf');\n}\n\n@font-face {\n  font-family: 'Poppins';\n  font-weight: 300;\n  font-style: italic;\n  src: url('../fonts/Poppins/Poppins-LightItalic.ttf');\n}\n\n@font-face {\n  font-family: 'Poppins';\n  font-weight: 400;\n  font-style: italic;\n  src: url('../fonts/Poppins/Poppins-Italic.ttf');\n}\n\n@font-face {\n  font-family: 'Poppins';\n  font-weight: 500;\n  font-style: italic;\n  src: url('../fonts/Poppins/Poppins-MediumItalic.ttf');\n}\n\n@font-face {\n  font-family: 'Poppins';\n  font-weight: 600;\n  font-style: italic;\n  src: url('../fonts/Poppins/Poppins-SemiBoldItalic.ttf');\n}\n\n@font-face {\n  font-family: 'Poppins';\n  font-weight: 700;\n  font-style: italic;\n  src: url('../fonts/Poppins/Poppins-BoldItalic.ttf');\n}\n\n@font-face {\n  font-family: 'Poppins';\n  font-weight: 800;\n  font-style: italic;\n  src: url('../fonts/Poppins/Poppins-ExtraBoldItalic.ttf');\n}\n\n@font-face {\n  font-family: 'Poppins';\n  font-weight: 900;\n  font-style: italic;\n  src: url('../fonts/Poppins/Poppins-BlackItalic.ttf');\n}\n\n@font-face {\n  font-weight: 100;\n  font-family: Montserrat;\n  src: url(\"../fonts/Montserrat/Montserrat-Thin.ttf\");\n}\n\n@font-face {\n  font-weight: 100;\n  font-family: Montserrat;\n  font-style: italic;\n  src: url(\"../fonts/Montserrat/Montserrat-ThinItalic.ttf\");\n}\n\n@font-face {\n  font-weight: 300;\n  font-family: Montserrat;\n  src: url(\"../fonts/Montserrat/Montserrat-Light.ttf\");\n}\n\n@font-face {\n  font-weight: 300;\n  font-family: Montserrat;\n  font-style: italic;\n  src: url(\"../fonts/Montserrat/Montserrat-LightItalic.ttf\");\n}\n\n@font-face {\n  font-weight: 400;\n  font-family: Montserrat;\n  src: url(\"../fonts/Montserrat/Montserrat-Regular.ttf\");\n}\n\n@font-face {\n  font-weight: 400;\n  font-family: Montserrat;\n  font-style: italic;\n  src: url(\"../fonts/Montserrat/Montserrat-Italic.ttf\");\n}\n\n@font-face {\n  font-weight: 500;\n  font-family: Montserrat;\n  src: url(\"../fonts/Montserrat/Montserrat-Medium.ttf\");\n}\n\n@font-face {\n  font-weight: 500;\n  font-family: Montserrat;\n  font-style: italic;\n  src: url(\"../fonts/Montserrat/Montserrat-MediumItalic.ttf\");\n}\n\n@font-face {\n  font-weight: 700;\n  font-family: Montserrat;\n  src: url(\"../fonts/Montserrat/Montserrat-Bold.ttf\");\n}\n\n@font-face {\n  font-weight: 700;\n  font-family: Montserrat;\n  font-style: italic;\n  src: url(\"../fonts/Montserrat/Montserrat-BoldItalic.ttf\");\n}\n\n@font-face {\n  font-weight: 900;\n  font-family: Montserrat;\n  src: url(\"../fonts/Montserrat/Montserrat-Black.ttf\");\n}\n\n@font-face {\n  font-weight: 900;\n  font-family: Montserrat;\n  font-style: italic;\n  src: url(\"../fonts/Montserrat/Montserrat-BlackItalic.ttf\");\n}\n\n@font-face {\n  font-family: \"Inter\";\n  font-weight: 100;\n  src: url(\"../fonts/Inter/Inter-Thin.ttf\");\n}\n\n@font-face {\n  font-family: \"Inter\";\n  font-weight: 200;\n  src: url(\"../fonts/Inter/Inter-ExtraLight.ttf\");\n}\n\n@font-face {\n  font-family: \"Inter\";\n  font-weight: 300;\n  src: url(\"../fonts/Inter/Inter-Light.ttf\");\n}\n\n@font-face {\n  font-family: \"Inter\";\n  font-weight: 400;\n  src: url(\"../fonts/Inter/Inter-Regular.ttf\");\n}\n\n@font-face {\n  font-family: \"Inter\";\n  font-weight: 500;\n  src: url(\"../fonts/Inter/Inter-Medium.ttf\");\n}\n\n@font-face {\n  font-family: \"Inter\";\n  font-weight: 600;\n  src: url(\"../fonts/Inter/Inter-SemiBold.ttf\");\n}\n\n@font-face {\n  font-family: \"Inter\";\n  font-weight: 700;\n  src: url(\"../fonts/Inter/Inter-Bold.ttf\");\n}\n\n@font-face {\n  font-family: \"Inter\";\n  font-weight: 800;\n  src: url(\"../fonts/Inter/Inter-ExtraBold.ttf\");\n}\n\n@font-face {\n  font-family: \"Inter\";\n  font-weight: 900;\n  src: url(\"../fonts/Inter/Inter-Black.ttf\");\n}\n\n@font-face {\n  font-family: \"Inter\";\n  font-weight: 100;\n  font-style: italic;\n  src: url(\"../fonts/Inter/Inter-ThinItalic.ttf\");\n}\n\n@font-face {\n  font-family: \"Inter\";\n  font-weight: 200;\n  font-style: italic;\n  src: url(\"../fonts/Inter/Inter-ExtraLightItalic.ttf\");\n}\n\n@font-face {\n  font-family: \"Inter\";\n  font-weight: 300;\n  font-style: italic;\n  src: url(\"../fonts/Inter/Inter-LightItalic.ttf\");\n}\n\n@font-face {\n  font-family: \"Inter\";\n  font-weight: 400;\n  font-style: italic;\n  src: url(\"../fonts/Inter/Inter-Italic.ttf\");\n}\n\n@font-face {\n  font-family: \"Inter\";\n  font-weight: 500;\n  font-style: italic;\n  src: url(\"../fonts/Inter/Inter-MediumItalic.ttf\");\n}\n\n@font-face {\n  font-family: \"Inter\";\n  font-weight: 600;\n  font-style: italic;\n  src: url(\"../fonts/Inter/Inter-SemiBoldItalic.ttf\");\n}\n\n@font-face {\n  font-family: \"Inter\";\n  font-weight: 700;\n  font-style: italic;\n  src: url(\"../fonts/Inter/Inter-BoldItalic.ttf\");\n}\n\n@font-face {\n  font-family: \"Inter\";\n  font-weight: 800;\n  font-style: italic;\n  src: url(\"../fonts/Inter/Inter-ExtraBoldItalic.ttf\");\n}\n\n@font-face {\n  font-family: \"Inter\";\n  font-weight: 900;\n  font-style: italic;\n  src: url(\"../fonts/Inter/Inter-BlackItalic.ttf\");\n}\n\n@font-face {\n  font-weight: 100;\n  font-family: Roboto;\n  src: url(\"../fonts/Roboto/Roboto-Thin.ttf\");\n}\n\n@font-face {\n  font-weight: 100;\n  font-family: Roboto;\n  font-style: italic;\n  src: url(\"../fonts/Roboto/Roboto-ThinItalic.ttf\");\n}\n\n@font-face {\n  font-weight: 300;\n  font-family: Roboto;\n  src: url(\"../fonts/Roboto/Roboto-Light.ttf\");\n}\n\n@font-face {\n  font-weight: 300;\n  font-family: Roboto;\n  font-style: italic;\n  src: url(\"../fonts/Roboto/Roboto-LightItalic.ttf\");\n}\n\n@font-face {\n  font-weight: 400;\n  font-family: Roboto;\n  src: url(\"../fonts/Roboto/Roboto-Regular.ttf\");\n}\n\n@font-face {\n  font-weight: 400;\n  font-family: Roboto;\n  font-style: italic;\n  src: url(\"../fonts/Roboto/Roboto-Italic.ttf\");\n}\n\n@font-face {\n  font-weight: 500;\n  font-family: Roboto;\n  src: url(\"../fonts/Roboto/Roboto-Medium.ttf\");\n}\n\n@font-face {\n  font-weight: 500;\n  font-family: Roboto;\n  font-style: italic;\n  src: url(\"../fonts/Roboto/Roboto-MediumItalic.ttf\");\n}\n\n@font-face {\n  font-weight: 700;\n  font-family: Roboto;\n  src: url(\"../fonts/Roboto/Roboto-Bold.ttf\");\n}\n\n@font-face {\n  font-weight: 700;\n  font-family: Roboto;\n  font-style: italic;\n  src: url(\"../fonts/Roboto/Roboto-BoldItalic.ttf\");\n}\n\n@font-face {\n  font-weight: 900;\n  font-family: Roboto;\n  src: url(\"../fonts/Roboto/Roboto-Black.ttf\");\n}\n\n@font-face {\n  font-weight: 900;\n  font-family: Roboto;\n  font-style: italic;\n  src: url(\"../fonts/Roboto/Roboto-BlackItalic.ttf\");\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
